"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.emitToPlots = void 0;
const rc_js_util_1 = require("rc-js-util");
/**
 * @public
 * Emits the event on all connected plots.
 *
 * @remarks
 * Has a higher overhead due to arg spreading so shouldn't be used in performance critical sections.
 */
function emitToPlots(chart, event, ...args) {
    rc_js_util_1._Array.forEach(chart.getPlots(), (plot) => {
        plot.eventService
            .getCategory(event)
            .emit(...args);
    });
}
exports.emitToPlots = emitToPlots;
//# sourceMappingURL=emit-to-plots.js.map